import colors from '@theme/colors';
import { scale, verticalScale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  bottomView: {
    alignSelf: 'stretch',
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    marginHorizontal: 0,
    marginTop: 0,
    paddingTop: verticalScale(10),
  },
  container: { flex: 1 },
  okButton: { marginBottom: 0, paddingVertical: scale(8) },
  promoSection: { paddingBottom: verticalScale(6), paddingTop: verticalScale(16) },
  referralBanner: { marginBottom: 0, marginHorizontal: 0, marginTop: verticalScale(12) },
  scrollBody: { flexGrow: 1, justifyContent: 'space-between' },
  scrollContentContainer: { flexGrow: 1, paddingBottom: verticalScale(12), paddingHorizontal: scale(16) },
  scrollView: { flex: 1 },
  successImage: { alignSelf: 'center', marginTop: verticalScale(28) },
  successReportParent: { alignItems: 'center', marginTop: verticalScale(24), paddingHorizontal: scale(8) },
  successSection: { marginBottom: verticalScale(8) },
  txtSuccess: status => ({
    color: status === 'PENDING' ? colors.warning.sunflower : colors.success.cactus,
    textAlign: 'center',
  }),
  txtSuccessDetails: { color: colors.neutral.charcoal, marginTop: verticalScale(12), textAlign: 'center' },
  txtTarikGaji: { color: colors.neutral.darkMist, marginTop: verticalScale(12), textAlign: 'center' },
  txtTransferAmount: { color: colors.secondary.orchid, marginTop: verticalScale(12) },
});
export default styles;
